import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { _get, _post, _put } from "../../../api/apiClient";
import { setLoaderFalse, setLoaderTrue } from "../../../Redux/loaderSlice";
import { CustomSuccess } from "../../../api/CustomSuccess";
import { API_STATUS } from "../sliceUtil";
import store from "../../../app/store";
import { CustomError } from "../../../api/CustomError";
import { USER_TYPE } from "../../../utils/global";
import { USER_MANAGEMENT_STATUS } from "../../../Components/Bank/usermanagement/userManagementConstant";

const initUserManagementState = {
  userManagement: {
    roles: null,
    users: null,
    totalCount: null,
  },
  userManagementIsLoading: API_STATUS.STATUS_IDLE,
  pendingInvitation: {
    totalCount: null,
  },
  pendingInvitationIsLoading: API_STATUS.STATUS_IDLE,
};

const _userRole = () => {
  const state = store.getState();
  return state?.authReducer?.userData?.role;
};

const _orgClientId = () => {
  const state = store.getState();
  return state?.authReducer?.userData?.orgClientId;
};

const _idrssd = () => {
  const state = store.getState();
  return state?.authReducer?.userData?.idrssd;
};

const _resellerClientId = () => {
  const state = store.getState();
  return state?.authReducer?.userData?.client_Id;
};

export const fetchUserData = createAsyncThunk(
  "user/fetchUser",
  async ({ paginationObj, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Fetched User successfully.",
        errorMessage: "Failed to fetch user!",
      };
      const _active =
        paginationObj?.selectedFilter?.code !== ""
          ? `?is_active=${paginationObj?.selectedFilter?.code}&`
          : "?";
      const _pageNumber = paginationObj?.currentPage
        ? `PageNumber=${paginationObj?.currentPage}`
        : "";
      const _pageSize =
        paginationObj?.limit > 0 ? `&PageSize=${paginationObj?.limit}` : "";
      const _status = paginationObj?.selectedFilter?.code
        ? `&Status=${paginationObj?.selectedFilter?.code}`
        : "";
      const _sortBy = paginationObj?.sortObj?.sortOrder
        ? `&SortBy=${paginationObj?.sortObj?.sortOrder}`
        : "";
      const _sortField = paginationObj?.sortObj?.sortField
        ? `&SortField=${paginationObj?.sortObj?.sortField}`
        : "";
      const _searchBy = paginationObj?.searchData
        ? `&SearchBy=${paginationObj?.searchData}`
        : "";

      const response =
        _userRole()?.toLowerCase() !== USER_TYPE.RESELLER.toLowerCase() &&
        _userRole()?.toLowerCase() !== USER_TYPE.SUPER_ADMIN.toLowerCase()
          ? await _get(
              `/clientuser/client/${_idrssd()}${_active}${_pageNumber}${_pageSize}${_status}${_sortBy}${_sortField}${_searchBy}`,
            )
          : await _get(
              `/${_resellerClientId()}/reseller/user${_active}${_pageNumber}${_pageSize}${_status}${_sortBy}${_sortField}${_searchBy}`,
            );

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });
      if (!disableLoader) thunkAPI.dispatch(setLoaderFalse());

      const rolesPayload = await thunkAPI.dispatch(
        fetchAllUserRole({ disableLoader: true }),
      );

      const users =
        _userRole()?.toLowerCase() !== USER_TYPE.RESELLER.toLowerCase() &&
        _userRole()?.toLowerCase() !== USER_TYPE.SUPER_ADMIN.toLowerCase()
          ? {
              users: data?.data,
              totalRecords: data?.totalRecords,
            }
          : {
              users: data?.data,
              totalRecords: data?.totalRecords,
            };

      return {
        userData: users,
        roleData: rolesPayload?.payload?.data,
        paginationObj,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const fetchAllUserRole = createAsyncThunk(
  "userrole/fetchuserrole",
  async ({ disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Updated User Role successfully.",
        errorMessage: "Failed to update user role!",
      };
      const response = await _get(
        `007a1000-0000-0000-0000-000000000003/role`,
        {},
      );

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });
      if (!disableLoader) thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const fetchPendingUserData = createAsyncThunk(
  "pendinguser/fetchPendingUser",
  async ({ paginationObj, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Fetched Pending-User successfully.",
        errorMessage: "Failed to fetch pending-user!",
      };

      const id =
        _userRole()?.toLowerCase() === USER_TYPE.RESELLER.toLowerCase() ||
        _userRole()?.toLowerCase() === USER_TYPE.SUPER_ADMIN.toLowerCase()
          ? _orgClientId()
          : _idrssd();

      const _active =
        paginationObj?.selectedFilter?.code !== ""
          ? `?is_active=${paginationObj?.selectedFilter?.code}&`
          : "?";
      const _pageNumber = paginationObj?.currentPage
        ? `PageNumber=${paginationObj?.currentPage}`
        : "";
      const _pageSize =
        paginationObj?.limit > 0 ? `&PageSize=${paginationObj?.limit}` : "";
      const _status = paginationObj?.selectedFilter?.code
        ? `&Status=${paginationObj?.selectedFilter?.code}`
        : "";
      const _sortBy = paginationObj?.sortObj?.sortOrder
        ? `&SortBy=${paginationObj?.sortObj?.sortOrder}`
        : "";
      const _sortField = paginationObj?.sortObj?.sortField
        ? `&SortField=${paginationObj?.sortObj?.sortField}`
        : "";
      const _searchBy = paginationObj?.searchData
        ? `&SearchBy=${paginationObj?.searchData}`
        : "";

      const response = await _get(
        `/applicant/${id}${_active}${_pageNumber}${_pageSize}${_status}${_sortBy}${_sortField}${_searchBy}`,
      );

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updatePendingUserData = createAsyncThunk(
  "updateuser/updatePendingUser",
  async ({ id, inviteStatus, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Registration request is approved successfully!",
        errorMessage: "Failed to update user!",
      };
      const response = await _put(
        `/applicant/${id}/status?status=${inviteStatus}`,
        {},
      );

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: false,
        });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateUserData = createAsyncThunk(
  "updateuser/updateuser",
  async ({ id, userData, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "User details updated successfully!",
        errorMessage: "Failed to update user details!",
      };
      const response = await _put(`clientuser/${id}`, userData);

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: false,
        });

      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const inviteUserData = createAsyncThunk(
  "inviteuser/inviteuser",
  async (
    { paginationObj, id, userData, disableLoader, userRole },
    thunkAPI,
  ) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage:
          "The invitation has been sent to the user successfully!",
        errorMessage: "Failed to invite user!",
      };
      const response = await _post(`clientuser/invite`, userData);

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      await thunkAPI.dispatch(fetchUserData({ paginationObj }));

      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: false,
        });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const revokeAccessThunk = createAsyncThunk(
  "updateuser/revokeAccess",
  async ({ isRevoke, disableLoader = false }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: `${isRevoke ? "Revoked" : "Allowed"} access successfully!`,
        errorMessage: "Failed to configure access!",
      };
      const response = await _put(
        `/${_resellerClientId()}/reseller/revoke?isRevoke=${isRevoke}`,
      );

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: false,
        });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const userManagementSlice = createSlice({
  name: "usermanagement",
  initialState: initUserManagementState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (_state) => ({
        ..._state,
        userManagementIsLoading: API_STATUS.STATUS_LOADING,
      }))
      .addCase(fetchUserData.fulfilled, (_state, action) => {
        // Filter roles if we have them
        const filteredRoles = action?.payload?.roleData?.filter((role) =>
          role?.key?.startsWith("bondai_ap_client"),
        );
        // Combine with user data
        const finalUserData = action?.payload?.userData?.users?.map((user) => {
          return {
            ...user,
            ...{
              attachedUserRole: filteredRoles?.find(
                (role) => user?.clientUserRole === role?.display_Value,
              ),
            },
          };
        });
        return {
          ..._state,
          userManagementIsLoading: API_STATUS.STATUS_SUCCESS,
          userManagement: {
            roles: filteredRoles,
            users: finalUserData,
            totalCount: action?.payload?.userData?.totalRecords,
          },
        };
      })
      .addCase(fetchUserData.rejected, (_state, action) => ({
        userManagementIsLoading: API_STATUS.STATUS_FAILURE,
        userManagement: {
          message: action.error.message || "Error while fetching user data",
        },
      }))
      .addCase(fetchPendingUserData.pending, (_state) => ({
        ..._state,
        pendingInvitationIsLoading: API_STATUS.STATUS_LOADING,
      }))
      .addCase(fetchPendingUserData.fulfilled, (_state, action) => {
        const updatedData = action?.payload?.data?.data?.map((item) => {
          if (item.referredByEmailID === "") {
            return {
              ...item,
              referredByEmailID: "Self Registered",
              displayStatus: item?.isExpired
                ? USER_MANAGEMENT_STATUS.bondai_applicant_status_expired
                : USER_MANAGEMENT_STATUS[item?.status],
            };
          }
          return {
            ...item,
            displayStatus: item?.isExpired
              ? USER_MANAGEMENT_STATUS.bondai_applicant_status_expired
              : USER_MANAGEMENT_STATUS[item?.status],
          };
        });
        return {
          ..._state,
          pendingInvitationIsLoading: API_STATUS.STATUS_SUCCESS,
          pendingInvitation: {
            invitations: updatedData,
            totalCount: action?.payload?.data?.totalRecords,
          },
        };
      })
      .addCase(fetchPendingUserData.rejected, (_state, action) => ({
        pendingInvitationIsLoading: API_STATUS.STATUS_FAILURE,
        pendingInvitation: {
          message: action.error.message || "Error while fetching user data",
        },
      }));
  },
});

export const selectUserManagement = (_state) => _state?.userManagementReducer;
